import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
/**
 * Enumerations von Syncfusion bsp. Toolbar-Items
 * node_modules/@syncfusion/ej2-pdfviewer/src/pdfviewer/base/types.d.ts
 */
import {
  AllowedInteraction,
  AnnotationAddEventArgs,
  AnnotationMoveEventArgs,
  AnnotationPropertiesChangeEventArgs,
  AnnotationRemoveEventArgs,
  AnnotationResizeEventArgs,
  AnnotationSelectEventArgs,
  AnnotationService,
  AnnotationSettings,
  AnnotationUnSelectEventArgs,
  BookmarkViewService,
  CommentEventArgs,
  DisplayMode,
  DynamicStampItem,
  FormDesignerService,
  FormFieldsService,
  FreeTextSettings,
  LinkAnnotationService,
  LoadEventArgs,
  MagnificationService,
  NavigationService,
  PdfViewerComponent,
  PrintService,
  SignatureSelectEventArgs,
  SignatureUnselectEventArgs,
  SignStampItem,
  StandardBusinessStampItem,
  StickyNotesSettings,
  TextAlignment,
  TextSearchService,
  TextSelectionEndEventArgs,
  TextSelectionService,
  ThumbnailViewService,
  ToolbarService,
} from '@syncfusion/ej2-angular-pdfviewer';
import {ExcSecurityService} from 'exc-security-v2';
import {L10n, loadCldr} from '@syncfusion/ej2-base';
import {ExgModalService, ExgPopupComponent} from 'exc-controls-v2';
import {environment} from '../../../environments/environment';
import {ApplicationService} from '../../services/application.service';
import {CustomStampSettings, HandWrittenSignatureSettings} from '@syncfusion/ej2-pdfviewer/src/pdfviewer/pdfviewer';

@Component({
  selector: 'app-exc-pdfviewer-v2',
  templateUrl: './exc-pdfviewer-v2.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    LinkAnnotationService, BookmarkViewService, MagnificationService, ThumbnailViewService, ToolbarService,
    NavigationService, TextSearchService, TextSelectionService, PrintService,
    AnnotationService, FormFieldsService, FormDesignerService]
})
export class ExcPdfviewerv2Component extends ExcTranslation implements OnInit, AfterViewInit {
  /**
   * View-Childs
   */
  @ViewChild(PdfViewerComponent) VCSyncfusionPdfViewer!: PdfViewerComponent;
  @ViewChild(PdfViewerComponent, {read: ElementRef}) DivPdfViewer!: ElementRef;
  @ViewChild('fileUpload') VCfileUpload!: ElementRef<HTMLInputElement>;
  @ViewChild('VCStempelMenu', {read: ExgPopupComponent}) VCStempelMenu!: ExgPopupComponent;
  /**
   * Output
   */
  @Output() annotationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationUnselected: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationModeChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() annotationPropertiesChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() commentAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() commentChanged: EventEmitter<any> = new EventEmitter<any>();

  @Output() signatureSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() signatureUnSelect: EventEmitter<any> = new EventEmitter<any>();

  @Output() viewerPageClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewerTextSelection: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewerDocumentLoaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() ready: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Input
   */
  @Input()
  set docPath(value: string) {
    this._docPath = value;
    this.init = true;
  }
  get docPath(): string {
    return this._docPath;
  }
  private _docPath!: string;
  @Input()
  set docName(value: string) {
    this._docName = value;
  }
  get docName(): string {
    return this._docName;
  }
  private _docName = 'fileName';
  @Input()
  set docID(value: string) {
    this._docID = value;
  }
  get docID(): string {
    return this._docID;
  }
  _docID = '';
  @Input()
  set docAnnotations(value: any) {
    if (typeof value === 'string') {
      this._docAnnotations = JSON.parse(value);
    } else {
      this._docAnnotations = value;
    }
  }
  get docAnnotations(): any {
    return this.VCSyncfusionPdfViewer ? this.VCSyncfusionPdfViewer.annotationCollection : this._docAnnotations;
  }
  _docAnnotations: any[] = [];
  @Input()
  canShowAnnotationToolbar = false;
  @Input()
  showOnlyStamps = true;

  @Input()
  userStempel: any[] = [];
  stempelFilter = '';
  get userStempelFiltered(): any[] {
    if (!this.stempelFilter) {
      return this.userStempel;
    }
    const f = this.stempelFilter.toLowerCase();
    return this.userStempel.filter(s => s.stpName?.toLowerCase().includes(f));
  }
  init = false;
  service = environment.rest.PdfViewerUrl;
  /**
   * node_modules/@syncfusion/ej2-pdfviewer/src/pdfviewer/pdfviewer.d.ts
   * toolbarItemsConfig
   *
   */
  viewerConfig = {
    defaultValues: {
      annotationInteractions: [
        AllowedInteraction.Delete, AllowedInteraction.Move, AllowedInteraction.PropertyChange,
        AllowedInteraction.Resize, AllowedInteraction.Select
      ],
      toolbarItems: ['PageNavigationTool', 'MagnificationTool', 'PanTool', 'SelectionTool', 'SearchOption', 'UndoRedoTool', 'AnnotationEditTool', 'CommentTool', 'PrintOption', 'DownloadOption'],
    },
    toolbarItemsConfig: {
      showTooltip: true,
      toolbarItems: [
        'PageNavigationTool', 'MagnificationTool', 'PanTool', 'SelectionTool', 'SearchOption', 'PrintOption', 'DownloadOption'
      ],
      // AnnotationToolbarItem[]
      annotationToolbarItems: [
        'HighlightTool' , 'UnderlineTool' , 'StrikethroughTool' , 'ShapeTool' ,
        'CalibrateTool' , 'ColorEditTool' , 'StrokeColorEditTool' , 'ThicknessEditTool',
        'OpacityEditTool' , 'AnnotationDeleteTool' , 'StampAnnotationTool' , 'HandWrittenSignatureTool' ,
        'InkAnnotationTool' , 'FreeTextAnnotationTool' , 'FontFamilyAnnotationTool' , 'FontSizeAnnotationTool' ,
        'FontStylesAnnotationTool' , 'FontAlignAnnotationTool' , 'FontColorAnnotationTool'
      ],
      // FormDesignerToolbarItem[]
      formDesignerToolbarItems: []
    },

    toolbar: {
      enableTextSelection: true,
      enableCommentPanel: true,
      enableAnnotation: true,
      enableAnnotationToolbar: false,
    },
    visibility: {
      isAnnotationToolbarOpen: false,
      isCommandPanelOpen: false,
    },
    settings: {
      AnnotationSettings: {
        allowedInteractions: [AllowedInteraction.Select],
        author: this.excSecurity.UserName,
        isLock: true,
        customData: {},
        skipPrint: false,
        skipDownload: false,
      } as AnnotationSettings,
      customStampSettings: {
        opacity: 1,
        author: 'Guest',
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        minHeight: 0,
        minWidth: 0,
        maxWidth: 0,
        maxHeight: 0,
        isLock: true,
        enableCustomStamp: true,
        customStamps: [{
          customStampName: 'Image',
        }],
        allowedInteractions: ['Select'],
        isPrint: true
      } as CustomStampSettings,
      freeTextSettings: {
        isLock: true,
        author: this.excSecurity.UserName,
        defaultText: 'im Editor editieren',
        fillColor: '#fdff9480',
        borderColor: '#7D2525',
        borderWidth: 1,
        allowedInteractions: ['Select'],
      } as unknown as FreeTextSettings,
      stickyNoteSettings: {
        isLock: true,
        author: this.excSecurity.UserName,
        allowedInteractions: ['Select'],
      } as StickyNotesSettings,
      handWrittenSignatureSettings: {
        signatureDialogSettings: {
          // tslint:disable-next-line:no-bitwise
          displayMode: DisplayMode.Draw | DisplayMode.Text | DisplayMode.Upload,
          hideSaveSignature: true,
        },
        initialDialogSettings: {
          // tslint:disable-next-line:no-bitwise
          displayMode: DisplayMode.Draw | DisplayMode.Text | DisplayMode.Upload,
          hideSaveSignature: true,
        },
      } as HandWrittenSignatureSettings
    },

  };

  toolbar = {
    navigation: {
      firstPage: true,
      lastPage: false,
      currentPage: 1,
      previousClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.navigation.goToPreviousPage();
      },
      nextClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.navigation.goToNextPage();
      },
      pageChanged: (value: any): void => {
        if (value >= 1 && value <= this.VCSyncfusionPdfViewer.pageCount) {
          this.VCSyncfusionPdfViewer.navigation.goToPage(value);
        }
      }
    },
    file: {
      printClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.print.print();
      },
      downloadClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.download();
      },
      downloadStart: (): void => {
        this.VCSyncfusionPdfViewer.downloadFileName = this.docName;
      },
    },
    textSearch: {
      isActiveSearch: false,
      searchVisible: false,
      canSearchNext: false,
      canSearchPrevious: false,
      searchText: '',
      matchCount: 0,
      matchPosition: 1,
      textSearch: (event?: any) => {
        if (!this.toolbar.textSearch.isActiveSearch
          && this.toolbar.textSearch.searchText.length !== 0
        ) {
          this.VCSyncfusionPdfViewer.textSearchModule.searchText(this.toolbar.textSearch.searchText, false);
        } else {
          this.toolbar.textSearch.resetSearchText();
        }
      },
      textSearchStart: (event: any) => {
        this.toolbar.textSearch.isActiveSearch = true;
      },
      textSearchComplete: (event: any) => {
        this.toolbar.textSearch.isActiveSearch = false;

        if (this.viewer.text.dokumentText.length > 0 && this.toolbar.textSearch.searchText.length > 0) {
          this.toolbar.textSearch.matchCount =
            this.viewer.text.dokumentText.toLowerCase()
              .split(this.toolbar.textSearch.searchText.toLowerCase()).length - 1;
        }
        this.toolbar.textSearch.updateSearchBtns();
      },
      searchNext: (): void => {
        if (this.toolbar.textSearch.matchPosition < this.toolbar.textSearch.matchCount
          && this.toolbar.textSearch.searchText.length !== 0
          && this.toolbar.textSearch.matchCount > 0
        ) {
          this.VCSyncfusionPdfViewer.textSearchModule.searchNext();
          this.toolbar.textSearch.matchPosition = this.toolbar.textSearch.matchPosition + 1;
          this.toolbar.textSearch.updateSearchBtns();
        }
      },
      searchPrevious: (): void => {
        if (this.toolbar.textSearch.matchPosition > 1
          && this.toolbar.textSearch.searchText.length !== 0
          && this.toolbar.textSearch.matchCount > 0
        ) {
          this.VCSyncfusionPdfViewer.textSearchModule.searchNext();
          this.toolbar.textSearch.matchPosition = this.toolbar.textSearch.matchPosition - 1;
          this.toolbar.textSearch.updateSearchBtns();
        }
      },
      updateSearchBtns(): void {
        if (this.searchText.length === 0) {
          this.canSearchNext = false;
          this.canSearchPrevious = false;
          if (this.matchCount > 0) {
            this.matchCount = 0;
          }
        } else if (this.searchText.length !== 0
          && this.matchCount > 0
        ) {
          this.canSearchPrevious = this.matchPosition !== 1;
          this.canSearchNext = this.matchPosition !== this.matchCount;
        }
      },
      resetSearchText: (): void => {
        this.VCSyncfusionPdfViewer.textSearchModule.cancelTextSearch();
        this.toolbar.textSearch.isActiveSearch = false;
        this.toolbar.textSearch.matchCount = 0;
        this.toolbar.textSearch.matchPosition = 1;
        if (this.toolbar.textSearch.searchText.length > 0) {
          this.toolbar.textSearch.searchText = '';
        }
        this.toolbar.textSearch.updateSearchBtns();
      }
    },
    menu: {
      showAnnotationToolbar: false,
      toggleAnnotationToolbar: (value?: boolean): void => {
        if (this.canShowAnnotationToolbar) {
          this.toolbar.menu.showAnnotationToolbar = value ? value : !this.toolbar.menu.showAnnotationToolbar;
        }
      },
      toggleTextSearch: (event: any): void => {
        this.toolbar.textSearch.searchVisible = !this.toolbar.textSearch.searchVisible;
        if (!this.toolbar.textSearch.searchVisible) {
          this.VCSyncfusionPdfViewer.textSearchModule.resetTextSearch();
          this.toolbar.textSearch.isActiveSearch = false;
          this.toolbar.textSearch.matchCount = 0;
          this.toolbar.textSearch.matchPosition = 1;
        } else {
          this.toolbar.textSearch.searchText = '';
          this.VCSyncfusionPdfViewer.textSearchModule.initiateSearch('');
        }
      },
      toggleStempelMenu: (e: any): void => {
        if (this.VCStempelMenu) {
          this.VCStempelMenu.visibility === 'hidden'
            ? this.VCStempelMenu.openUnderLeft(e)
            : this.VCStempelMenu.close();
        }
      },
    },
    magnification: {
      fitPage: false,
      fitWidth: false,
      fitAuto: false,
      zoomIn: false,
      zoomOut: false,
      pageFitPageClicked: (e?: any): void => {
        this.VCSyncfusionPdfViewer.magnification.fitToPage();
        this.toolbar.magnification.updateZoomButtons();
        this.toolbar.magnification.fitPage = true;
      },
      pageFitWidthClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.magnification.fitToWidth();
        this.toolbar.magnification.updateZoomButtons();
        this.toolbar.magnification.fitWidth = true;
      },
      pageFitAutoClicked: (e?: any): void => {
        this.VCSyncfusionPdfViewer.magnification.fitToAuto();
        this.toolbar.magnification.updateZoomButtons();
        this.toolbar.magnification.fitAuto = true;
      },
      zoomInClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.magnification.zoomIn();
        this.toolbar.magnification.updateZoomButtons();
      },
      zoomOutClicked: (e: any): void => {
        this.VCSyncfusionPdfViewer.magnification.zoomOut();
        this.toolbar.magnification.updateZoomButtons();
      },
      zoomTo: (value: any): void => {
        if (this.VCSyncfusionPdfViewer.zoomValue <= 10
            && this.VCSyncfusionPdfViewer.zoomValue >= 400
        ) {
          this.VCSyncfusionPdfViewer.magnification.zoomTo(value);
        }
      },
      updateZoomButtons: (): void => {
        if (this.VCSyncfusionPdfViewer.zoomValue <= 10) {
          this.toolbar.magnification.fitPage  = false;
          this.toolbar.magnification.fitWidth  = false;
          this.toolbar.magnification.fitAuto  = false;
          this.toolbar.magnification.fitPage  = false;
          this.toolbar.magnification.zoomIn   = false;
          this.toolbar.magnification.zoomOut  = true;
        } else if (this.VCSyncfusionPdfViewer.zoomValue >= 400) {
          this.toolbar.magnification.fitPage  = false;
          this.toolbar.magnification.fitWidth  = false;
          this.toolbar.magnification.fitAuto  = false;
          this.toolbar.magnification.fitPage  = false;
          this.toolbar.magnification.zoomIn   = true;
          this.toolbar.magnification.zoomOut  = false;
        } else {
          this.toolbar.magnification.fitPage  = false;
          this.toolbar.magnification.fitWidth  = false;
          this.toolbar.magnification.fitAuto  = false;
          this.toolbar.magnification.zoomIn   = false;
          this.toolbar.magnification.zoomOut  = false;
        }
      }
    },
  };
  viewer = {
    text: {
      dokumentText: '',

      extractText: (event: any): void => {
        // Extract the Text data.
        // console.log(event.documentTextCollection[1]);
        // console.log(event.documentTextCollection[1][1].TextData);

        // Extract Text in the Page.
        // console.log(event.documentTextCollection[1][1].PageText);

        // Extracts the first text of the PDF document along with its bounds
        // console.log(event.documentTextCollection[1][1].TextData[0].Bounds);

        if (event.documentTextCollection && event.documentTextCollection.length > 0) {
          if (this.viewer.text.dokumentText.length === 0) {
            for (const documentTextCollectionElement of this.VCSyncfusionPdfViewer.textSearchModule.documentTextCollection) {
              // console.log(
              //   documentTextCollectionElement[
              //     this.VCSyncfusionPdfViewer.textSearchModule.documentTextCollection.indexOf(documentTextCollectionElement)
              //     ]
              // );

              // TSLint Korregiert auf "pageText" das es aber nicht gibt bei der Enitity Eintrag
              this.viewer.text.dokumentText +=
                (documentTextCollectionElement[
                  this.VCSyncfusionPdfViewer.textSearchModule.documentTextCollection.indexOf(documentTextCollectionElement)
                  ] as any)?.PageText;
            }
          }
        }
      }
    },
    file: {
      documentLoaded: (event: LoadEventArgs): void => {
        this.toolbar.navigation.currentPage = 1;
        // this.toolbar.magnification.pageFitPageClicked();

        this.ready.emit();
        this.viewerDocumentLoaded.emit(event);
      }
    },
    reload: (): void => {
      if (this.docPath) {
        this.VCSyncfusionPdfViewer.unload();
        this.VCSyncfusionPdfViewer.load(this.docPath, '');
      }
    },
    selection: {
      textSelection: '',
      textSelected: (event: TextSelectionEndEventArgs): void => {
        this.viewer.selection.textSelection = event.textContent;
        this.viewerTextSelection.emit(event.textContent);
      }
    },
    annotation: {
      selectedAnnotationId: '',
      lastAddedAnnotationId: '',
      selectedAnnotation: undefined as any,
      selectedAnnotationClone: undefined as any,
      buttons: {
        menuStamps: true,
        customStamp: true,
        comment: false,
        highlighter: true,
        underline: true,
        strikethrough: true,
        check: true,
        xmark: true,
        uploadStamp: true,
        menuForms: true,
        formCircle: true,
        formSquare: true,
        formOctagon: false,
        formDash: true,
        freeText: true,
        stamp: false,
        drawing: true,
        signature: this.excSecurity.isFeatured('DEVELOPMENT'),
        menuFont: true,
        fontFamily: true,
        fontSize: true,
        fontBold: true,
        fontItalic: true,
        fontUnderline: true,
        fontStrikethrough: true,
        menuAlign: true,
        fontAlignLeft: true,
        fontAlignJustify: true,
        fontAlignRight: true,
        fontAlignCenter: true,
        fillColor: true,
        lineThickness: true,
        lineColor: true,
        brightness: true,
        annotationDelete: true,
        closeToolbar: true,
        circle: true
      },
      activeAnnotationMode: {
        mode: 'None' as any,
        dynamicStampItem: undefined as any,
        signStampItem: undefined as any,
        standardBusinessStampItem: undefined as any,
        stampImageBase64: undefined as string | undefined
      },
      currentTool: {
        highlighter: true,
        underline: true,
        strikethrough: true,
        check: true,
        xmark: true,
        formCircle: true,
        formSquare: true,
        formOctagon: true,
        formDash: true,
        freeText: true,
      },
      showSubmenu: {
        showFontColor: false,
        showFontSize: false,
        showStokeColor: false,
        showFillColor: false,
        showSliderThickness: false,
        showSliderOpacity: false,
        showStamps: false,
        showForms: true,
        showTextModifiers: false,
        showModifiers: false,
        showTextAlignments: false,
        resetMenues(): void {
          this.showModifiers = false;
          this.showTextModifiers = false;
          this.showTextAlignments = false;
        }
      },
      setAnnotationMode: (mode: any = 'None',
                          dynamicStampItem = undefined as any,
                          signStampItem = undefined as any,
                          standardBusinessStampItem = undefined as any,
                          stampImageBase64 = undefined as string | undefined
      ): void => {
        const input = {
          mode,
          dynamicStampItem,
          signStampItem,
          standardBusinessStampItem
        };

        if (!this.appSvc.helperObj.changed(this.viewer.annotation.activeAnnotationMode, input) || !input.mode || input.mode === 'None') {
          this.viewer.annotation.activeAnnotationMode = {
            mode: 'None',
            dynamicStampItem: undefined,
            signStampItem: undefined,
            standardBusinessStampItem: undefined,
            stampImageBase64: undefined
          };
          this.VCSyncfusionPdfViewer.annotationModule.setAnnotationMode('None');

          // Selection bereinigen
          this.VCSyncfusionPdfViewer.annotationModule.triggerAnnotationUnselectEvent();
          this.VCSyncfusionPdfViewer.annotationModule.clearSelection();

          this.VCSyncfusionPdfViewer.viewerBase.initiateTextSelection();
        } else if (input.mode  === 'customStamp') {
          // Selection bereinigen
          this.VCSyncfusionPdfViewer.annotationModule.triggerAnnotationUnselectEvent();
          this.VCSyncfusionPdfViewer.annotationModule.clearSelection();
          this.viewer.annotation.activeAnnotationMode = {
            mode: 'customStamp',
            dynamicStampItem,
            signStampItem: undefined,
            standardBusinessStampItem: undefined,
            stampImageBase64
          };
          this.VCSyncfusionPdfViewer.annotationModule.setAnnotationMode('None');
          if (dynamicStampItem === 'uploadStamp') {
            this.VCfileUpload.nativeElement.click();
          }
        } else {
          // Selection bereinigen
          this.VCSyncfusionPdfViewer.annotationModule.triggerAnnotationUnselectEvent();
          this.VCSyncfusionPdfViewer.annotationModule.clearSelection();
          // Mode setzen
          this.viewer.annotation.activeAnnotationMode = this.appSvc.helperObj.clone(input);
          this.VCSyncfusionPdfViewer.annotationModule.setAnnotationMode(
            mode,
            dynamicStampItem as DynamicStampItem,
            signStampItem as SignStampItem,
            standardBusinessStampItem as StandardBusinessStampItem
          );
        }
        this.viewer.annotation.showSubmenu.resetMenues();
        this.annotationModeChanged.emit(this.viewer.annotation.activeAnnotationMode);
      },
      reactivateMode: (): void => {
        const actualMode = this.viewer.annotation.activeAnnotationMode;
        if (actualMode.mode !== 'None') {
          // Mode setzen
          this.VCSyncfusionPdfViewer.annotationModule.setAnnotationMode(
            actualMode.mode,
            actualMode.dynamicStampItem,
            actualMode.signStampItem,
            actualMode.standardBusinessStampItem
          );
          this.annotationModeChanged.emit(this.viewer.annotation.activeAnnotationMode);
        }
      },
      addCustomStamp: (x: any, y: any, typeAnnotation: any, imageBase64?: string): void => {
        const check = 'data:image/png;base64,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';
        const cross = 'data:image/png;base64,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';
        const circle = 'data:image/png;base64,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';
        const blank = 'data:image/png;base64,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';

        const maxSize = 150;
        const img = imageBase64 ? new Image() : null;

        const add = (width: number, height: number) => {
          this.VCSyncfusionPdfViewer.annotation.addAnnotation('Stamp', {
            offset: {x, y},
            width,
            height,
            isLock: false,
            pageNumber: this.VCSyncfusionPdfViewer.currentPageNumber,
            customStamps: [
              {
                customStampName: 'Image',
                customStampImageSource:
                  imageBase64 ? imageBase64
                    : typeAnnotation === 'check' ? check
                      : typeAnnotation === 'circle' ? circle
                        : typeAnnotation === 'blank' ? blank
                          : cross
              },
            ],
          } as CustomStampSettings);
        };

        if (img) {
          img.onload = () => {
            const w = img.naturalWidth;
            const h = img.naturalHeight;
            add(
              w > h ? maxSize : Math.round((w / h) * maxSize),
              w > h ? Math.round((h / w) * maxSize) : maxSize
            );
          };
          img.src = imageBase64 as string;
        } else {
          add(12, typeAnnotation === 'circle' ? 12 : 15);
        }
      },
      modify: {
        fontColor: (value: string): void => {
          if (this.viewer.annotation.selectedAnnotation?.fontColor) {
            this.VCSyncfusionPdfViewer.annotationModule.modifyFontColor(value);
            this.viewer.annotation.selectedAnnotation.fontColor = value;
          }
        },
        fontSize: {
          increase: (): void => {
            if (this.viewer.annotation.selectedAnnotation?.fontSize) {
              this.viewer.annotation.selectedAnnotation.fontSize =
                this.viewer.annotation.selectedAnnotation?.fontSize + 1;
              this.VCSyncfusionPdfViewer.annotationModule
                .modifyFontSize(
                  this.viewer.annotation.selectedAnnotation.fontSize,
                  false
                );
            }
          },
          decrease: (): void => {
            if (this.viewer.annotation.selectedAnnotation?.fontSize) {
              this.viewer.annotation.selectedAnnotation.fontSize =
                this.viewer.annotation.selectedAnnotation?.fontSize - 1;
              this.VCSyncfusionPdfViewer.annotationModule
                .modifyFontSize(
                  this.viewer.annotation.selectedAnnotation.fontSize,
                  false
                );
            }
          },
          setSize: (value: any): void => {
            if (value !== this.viewer.annotation.selectedAnnotation.fontSize) {
              this.viewer.annotation.selectedAnnotation.fontSize = value;
              this.VCSyncfusionPdfViewer.annotationModule
                .modifyFontSize(
                  this.viewer.annotation.selectedAnnotation.fontSize,
                  false
                );
            }
          }
        },
        fontStyle: {
          changeBold: (): void => {
            if (this.viewer.annotation.selectedAnnotation?.fontStyle) {
              this.VCSyncfusionPdfViewer.annotationModule.modifyTextProperties(
                {isBold: !this.viewer.annotation.selectedAnnotation?.fontStyle.isBold}
                , 'bold'
              );
              this.viewer.annotation.selectedAnnotation.fontStyle.isBold =
                !this.viewer.annotation.selectedAnnotation?.fontStyle.isBold;
            }
          },
          changeUnderline: (): void => {
            if (this.viewer.annotation.selectedAnnotation?.fontStyle) {
              if (!this.viewer.annotation.selectedAnnotation?.fontStyle.isUnderline
                  && this.viewer.annotation.selectedAnnotation?.fontStyle.isStrikeout) {
                this.VCSyncfusionPdfViewer.annotationModule.modifyTextProperties(
                  {isStrikeout: false}
                  , 'strikeout'
                );
                this.viewer.annotation.selectedAnnotation.fontStyle.isStrikeout = false;
              }
              this.VCSyncfusionPdfViewer.annotationModule.modifyTextProperties(
                {isUnderline: !this.viewer.annotation.selectedAnnotation?.fontStyle.isUnderline}
                , 'underline'
              );
              this.viewer.annotation.selectedAnnotation.fontStyle.isUnderline =
                !this.viewer.annotation.selectedAnnotation?.fontStyle.isUnderline;
            }
          },
          changeStrikeout: (): void => {
            if (this.viewer.annotation.selectedAnnotation?.fontStyle) {
              if (!this.viewer.annotation.selectedAnnotation?.fontStyle.isStrikeout
                  && this.viewer.annotation.selectedAnnotation?.fontStyle.isUnderline) {
                this.VCSyncfusionPdfViewer.annotationModule.modifyTextProperties(
                  {isUnderline: false}
                  , 'underline'
                );
                this.viewer.annotation.selectedAnnotation.fontStyle.isUnderline = false;
              }
              this.VCSyncfusionPdfViewer.annotationModule.modifyTextProperties(
                {isStrikeout: !this.viewer.annotation.selectedAnnotation?.fontStyle.isStrikeout}
                , 'strikeout'
              );
              this.viewer.annotation.selectedAnnotation.fontStyle.isStrikeout =
                !this.viewer.annotation.selectedAnnotation?.fontStyle.isStrikeout;
            }
          },
          changeItalic: (): void => {
            if (this.viewer.annotation.selectedAnnotation?.fontStyle) {
              this.VCSyncfusionPdfViewer.annotationModule.modifyTextProperties(
                {isItalic: !this.viewer.annotation.selectedAnnotation?.fontStyle.isItalic}
                , 'italic'
              );
              this.viewer.annotation.selectedAnnotation.fontStyle.isItalic =
                !this.viewer.annotation.selectedAnnotation?.fontStyle.isItalic;
            }
          }
        },
        fontAlignment: (newValue: TextAlignment = 'Left'): void => {
          if (this.viewer.annotation.selectedAnnotation?.fontStyle) {
            this.VCSyncfusionPdfViewer.annotationModule.modifyTextAlignment(
              newValue
            );
            this.viewer.annotation.selectedAnnotation.textAlign = newValue;
          }
        },
        fillColor: (value: string): void => {
          if (this.viewer.annotation.selectedAnnotation?.fillColor) {
            this.VCSyncfusionPdfViewer.annotationModule.modifyFillColor(value);
            this.viewer.annotation.selectedAnnotation.fillColor = value;
          }
        },
        strokeColor: (value: string): void => {
          if (this.viewer.annotation.selectedAnnotation?.strokeColor) {
            this.VCSyncfusionPdfViewer.annotationModule.modifyStrokeColor(value);
            this.viewer.annotation.selectedAnnotation.strokeColor = value;
          }
        },
      },
      annotationEventListener: (event: AnnotationAddEventArgs
                                  | AnnotationMoveEventArgs
                                  | AnnotationRemoveEventArgs
                                  | AnnotationPropertiesChangeEventArgs
                                  | AnnotationResizeEventArgs
                                  | AnnotationSelectEventArgs
                                  | AnnotationUnSelectEventArgs
      ): void => {
        switch (event.name) {
          case 'annotationAdd': {
            this.viewer.annotation.selectedAnnotationId =
              (event as AnnotationAddEventArgs).annotationId;
            this.viewer.annotation.lastAddedAnnotationId =
              (event as AnnotationAddEventArgs).annotationId;

            if (!(['Highlight', 'Underline', 'Strikethrough', 'FreeText'].includes(
                    (event as AnnotationAddEventArgs).annotationType))
            ) {
              if (['Stamp', 'StickyNotes'].includes((event as AnnotationAddEventArgs).annotationType)) {
                const actualMode = this.viewer.annotation.activeAnnotationMode;
                this.viewer.annotation.setAnnotationMode(
                  actualMode.mode, actualMode.dynamicStampItem, actualMode.signStampItem, actualMode.standardBusinessStampItem
                );
              }
              this.viewer.annotation.reactivateMode();
            }

            this.annotationAdded.emit(event);
            break;
          }
          case 'annotationRemove': {
            this.viewer.annotation.selectedAnnotationId = '';
            this.viewer.annotation.selectedAnnotation = undefined;
            this.viewer.annotation.selectedAnnotation = undefined;

            this.annotationDeleted.emit(event);
            break;
          }
          case 'annotationSelect': {
            this.viewer.annotation.selectedAnnotationId = event.annotationId;
            this.viewer.annotation.selectedAnnotation = (event as AnnotationSelectEventArgs).annotation;
            this.viewer.annotation.selectedAnnotation = this.appSvc.helperObj.clone((event as AnnotationSelectEventArgs).annotation);

            if (this.viewer.annotation.activeAnnotationMode.mode !== 'None') {
              this.viewer.annotation.setAnnotationMode('None');
            }
            this.viewer.annotation.showSubmenu.showTextModifiers = (event as AnnotationSelectEventArgs).annotation.type === 'FreeText';
            this.viewer.annotation.showSubmenu.showModifiers = (event as AnnotationSelectEventArgs).annotation.type !== 'Stamp';

            this.annotationSelected.emit(event);
            break;
          }
          case 'annotationUnSelect': {
            this.viewer.annotation.selectedAnnotationId = '';
            this.viewer.annotation.selectedAnnotation = undefined;
            this.viewer.annotation.selectedAnnotationClone = undefined;

            this.VCSyncfusionPdfViewer.annotationModule.clearSelection();
            this.viewer.annotation.showSubmenu.resetMenues();

            this.annotationUnselected.emit(event);
            break;
          }
          case 'annotationPropertiesChange': {
            // console.log('changedAnnotation: ', this.viewer.annotation.selectedAnnotation, event);
            this.annotationPropertiesChanged.emit(event);
            break;
          }
          default: {
            this.annotationChanged.emit(event);
            break;
          }
        }
      },
      commentEventListener: (event: CommentEventArgs): void => {
        // console.log(event);
        const annotation = event.annotation;

        switch (event.name) {
          case 'commentAdd': {
            this.commentAdded.emit(event);
            this.commentChanged.emit(event);
            break;
          }
          case 'commentDelete': {
            this.commentDeleted.emit(event);
            this.commentChanged.emit(event);
            this.annotationChanged.emit(annotation);
            break;
          }
          case 'commentSelect': {
            this.commentSelected.emit(event);
            break;
          }
          default: {
            this.commentUpdated.emit(event);
            this.commentChanged.emit(event);
            this.annotationChanged.emit(annotation);
            break;
          }
        }
      },
      signatureSelect: (event: SignatureSelectEventArgs): void => {
        this.signatureSelect.emit(event);
      },
      signatureUnselect: (event: SignatureUnselectEventArgs): void => {
        this.signatureUnSelect.emit(event);
      },
    },
    page: {
      onClick: (event?: any): void => {
        this.viewerPageClicked.emit();

        if (this.viewer.annotation.activeAnnotationMode.mode === 'customStamp') {
          if (this.viewer.annotation.activeAnnotationMode.dynamicStampItem === 'uploadStamp') {
            this.VCfileUpload.nativeElement.click();
          } else {
            this.viewer.annotation.addCustomStamp(
              event.x / 1.33333,
              event.y / 1.33333,
              this.viewer.annotation.activeAnnotationMode.dynamicStampItem,
              this.viewer.annotation.activeAnnotationMode.stampImageBase64
            );
          }
        }
      }
    },
    hyperlinkClicked: (event: any): void => {
      event.cancel = true;
      this.modalService.showSimple(
        'Link Öffnen?', `Hyperlink: ${event.hyperlink}`, true, true, 'Öffnen', 'Abbrechen'
      ).subscribe((open) => {
        if (open) {
          window.open(event.hyperlink, '_blank');
        }
      });
    }
  };

  constructor(public enumSvc: EnumerationService,
              public excSecurity: ExcSecurityService,
              private modalService: ExgModalService,
              private appSvc: ApplicationService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    // @ts-ignore
    this.VCfileUpload.nativeElement
      .addEventListener('change', this.readFile.bind(this));
  }

  ngOnInit(): void {
    this.loadViewerTranslation();
    this.registerEvents();
  }

  readFile(args: any): void {
    // tslint:disable-next-line
    const uploadedFiles = args.target.files;
    if (args.target.files[0] !== null) {
      const uploadedFile: File = uploadedFiles[0];
      if (uploadedFile) {
        const reader: FileReader = new FileReader();
        reader.readAsDataURL(uploadedFile);
        // tslint:disable-next-line
        let proxy: any = this;
        // tslint:disable-next-line
        reader.onload = (e: any): void => {
          const uploadedFileUrl: string = e.currentTarget.result;
          const c: any = document.createElement('CANVAS');
          const ctx = c.getContext('2d');
          const image = new Image();
          // tslint:disable-next-line:typedef only-arrow-functions
          image.onload = function() {
            ctx.drawImage(image, 0, 0, 300, 150);
            const imagedata = ctx.canvas.toDataURL('image/png');
            // @ts-ignore
            const docID = document.getElementById('docID').innerHTML;
            // @ts-ignore
            const viewer = document.getElementById('pdfViewer_' + docID).ej2_instances[0];
            viewer.annotation.addAnnotation('Stamp', {
              offset: { x: 200, y: 130 },
              pageNumber: viewer.currentPageNumber,
              width: 200,
              height : 100,
              customStamps: [
                {
                  customStampName: 'Image',
                  customStampImageSource: imagedata,
                },
              ],
            });
          };
          image.src = uploadedFileUrl;
        };
      }
    }
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.viewer.reload();
    });
  }

  getFile(): Promise<FormData> {
    return this.VCSyncfusionPdfViewer
            .saveAsBlob()
            .then((blob: Blob) => {
              const formData = new FormData();
              formData.append('file[]', blob, `${Date.now().toString()}_${this.docName}`);
              return formData;
            })
            .catch(() => {
              return new FormData();
            });
  }

  enableAnnotationTools(allowed: boolean): void {
    if (!allowed) {
      if (this.toolbar.menu.showAnnotationToolbar) {
        this.toolbar.menu.toggleAnnotationToolbar(false);
      }
      this.viewerConfig.settings.AnnotationSettings.allowedInteractions = [
        AllowedInteraction.Select,
      ];
      this.viewerConfig.settings.freeTextSettings.allowedInteractions = [
        AllowedInteraction.Select,
      ];
      this.VCSyncfusionPdfViewer.annotationModule.updateSettings(this.viewerConfig.settings.AnnotationSettings);
    } else {
      this.VCSyncfusionPdfViewer.annotationModule.updateAnnotationAuthor(this.excSecurity.UserName);

      if (!this.toolbar.menu.showAnnotationToolbar) {
        this.toolbar.menu.showAnnotationToolbar = true;
      }
      this.viewerConfig.settings.AnnotationSettings.allowedInteractions = this.viewerConfig.defaultValues.annotationInteractions;
      this.viewerConfig.settings.freeTextSettings.allowedInteractions = this.viewerConfig.defaultValues.annotationInteractions;
      this.VCSyncfusionPdfViewer.annotationModule.updateSettings(this.viewerConfig.settings.AnnotationSettings);
    }
  }

  applyStempel(s: any): void {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;

      const ctx = canvas.getContext('2d');

      if (ctx) {
        ctx.drawImage(img, 0, 0);
        const png = canvas.toDataURL('image/png');

        this.viewer.annotation.setAnnotationMode(
          'customStamp',
          'userStempel',
          undefined,
          undefined,
          png
        );
      }
    };
    img.src = s.stpData;
    this.VCStempelMenu.close();
  }

  /**
   * Übersetzung L10n
   *
   * Übersetzt per Word + Teilanpassungen
   * Objekt im debugger entnommen, deckt also alle vorkommenden Wörter ab
   */
  loadViewerTranslation(): void {
    const cLang: string = this.currentLang() || 'de';

    if (cLang === 'de') {
      L10n.load({
        de: {
          PdfViewer: {
            PdfViewer: 'PDF-Viewer',
            Cancel: 'Abbrechen',
            'Download file': 'Download Datei',
            Download: 'Herunterladen',
            'Enter Password': 'Dieses Dokument ist Passwort geschützt. Bitte geben Sie das Passwort ein.',
            'File Corrupted': 'Datei beschädigt',
            'File Corrupted Content': 'Die Datei ist beschädigt und kann nicht geöffnet werden.',
            'Fit Page': 'Ganze Seite',
            'Fit Width': 'Voll Breite',
            Automatic: 'Automatisch',
            'Go To First Page': 'Erste Seite anzeigen',
            'Invalid Password': 'Falsches Passwort. Bitte versuchen Sie es erneut.',
            'Next Page': 'Nächste Seite anzeigen',
            OK: 'Okay',
            Open: 'Öffnen',
            'Page Number': 'Aktuelle Seitenzahl',
            'Previous Page': 'Vorherige Seite anzeigen',
            'Go To Last Page': 'Letzte Seite anzeigen',
            Zoom: 'Zoom',
            'Zoom In': 'Vergrößern',
            'Zoom Out': 'Verkleinern',
            'Page Thumbnails': 'Seitenminiaturansichten',
            Bookmarks: 'Lesezeichen',
            Print: 'Druckdatei',
            'Password Protected': 'Passwort erforderlich',
            Copy: 'Kopieren',
            'Text Selection': 'Textauswahl-Werkzeug',
            Panning: 'Schwenkmodus',
            'Text Search': 'Text suchen',
            'Find in document': 'Im Dokument suchen',
            'Match case': 'Groß-/Kleinschreibung abgleichen',
            Apply: 'Anwenden',
            GoToPage: 'Gehe zu Seite',
            'No matches': 'Der Viewer hat die Suche im Dokument abgeschlossen. Es wurden keine Übereinstimmungen mehr gefunden.',
            'No Text Found': 'Kein Text gefunden',
            Undo: 'Rückgängig',
            Redo: 'Wiederholen',
            Annotation: 'Hinzufügen oder Bearbeiten von Anmerkungen',
            FormDesigner: 'Hinzufügen und Bearbeiten von Formularfeldern',
            Highlight: 'Text hervorheben',
            Underline: 'Text unterstreichen',
            Strikethrough: 'Durchgestrichener Text',
            Delete: 'Anmerkungen löschen',
            Opacity: 'Undurchsichtigkeit',
            'Color edit': 'Farbe ändern',
            'Opacity edit': 'Deckkraft ändern',
            'Highlight context': 'Höhepunkt',
            'Underline context': 'Unterstreichen',
            'Strikethrough context': 'Durchgestrichen',
            'Server error': 'Der Webdienst hört nicht zu. PDF Viewer ist für alle seine Funktionen auf den Web-Service angewiesen. Starten Sie den Webdienst, um fortzufahren.',
            'Client error': 'Clientseitiger Fehler wurde gefunden. Überprüfen Sie die benutzerdefinierten Header, die in der AjaxRequestSettings-Eigenschaft bereitgestellt werden, und die Webaktionsmethoden in der ServerActionSettings-Eigenschaft.',
            'Open text': 'Offen',
            'First text': 'Erste Seite',
            'Previous text': 'Vorherige Seite',
            'Next text': 'Nächste Seite',
            'Last text': 'Letzte Seite',
            'Zoom in text': 'Vergrößern',
            'Zoom out text': 'Verkleinern',
            'Selection text': 'Auswahl',
            'Pan text': 'Herr',
            'Print text': 'Datei Drucken',
            'Search text': 'Datei durchsuchen',
            'Annotation Edit text': 'Anmerkung bearbeiten',
            'FormDesigner Edit text': 'Hinzufügen und Bearbeiten von Formularfeldern',
            'Line Thickness': 'Linienstärke',
            'Line Properties': 'Linieneigenschaften',
            'Start Arrow': 'Pfeil Start',
            'End Arrow': 'Pfeil zum Ende',
            'Line Style': 'Linienstil',
            'Fill Color': 'Füllfarbe',
            'Line Color': 'Linienfarbe',
            None: 'Nichts',
            'Open Arrow': 'Offen',
            'Closed Arrow': 'Geschlossen',
            'Round Arrow': 'Rund',
            'Square Arrow': 'Quadrat',
            'Diamond Arrow': 'Diamant',
            Butt: 'Hintern',
            Cut: 'Schneiden',
            Paste: 'Einfügen',
            'Delete Context': 'Löschen',
            Properties: 'Eigenschaften',
            'Add Stamp': 'Stempel hinzufügen',
            'Add Shapes': 'Hinzufügen von Shapes',
            'Stroke edit': 'Ändern der Konturfarbe',
            'Change thickness': 'Ändern der Rahmenstärke',
            'Add line': 'Zeile hinzufügen',
            'Add arrow': 'Pfeil hinzufügen',
            'Add rectangle': 'Rechteck hinzufügen',
            'Add circle': 'Kreis hinzufügen',
            'Add polygon': 'Polygon hinzufügen',
            'Add Comments': 'Kommentare hinzufügen',
            Comments: 'Kommentare',
            SubmitForm: 'Formular absenden',
            'No Comments Yet': 'Noch keine Kommentare',
            Accepted: 'Angenommen',
            Completed: 'Abgeschlossen',
            Cancelled: 'Abgebrochen',
            Rejected: 'Zurückgewiesen',
            'Leader Length': 'Länge des Leiters',
            'Scale Ratio': 'Skalierungsverhältnis',
            Calibrate: 'Kalibrieren',
            'Calibrate Distance': 'Abstand kalibrieren',
            'Calibrate Perimeter': 'Perimeter kalibrieren',
            'Calibrate Area': 'Bereich kalibrieren',
            'Calibrate Radius': 'Radius kalibrieren',
            'Calibrate Volume': 'Volumen kalibrieren',
            Depth: 'Tiefe',
            Closed: 'Geschlossen',
            Round: 'Rund',
            Square: 'Quadrat',
            Diamond: 'Diamant',
            Edit: 'Redigieren',
            Comment: 'Kommentar',
            'Comment Panel': 'Kommentarbereich',
            'Set Status': 'Status setzen',
            Post: 'Bereitstellen',
            Page: 'Seite',
            'Add a comment': 'Kommentieren',
            'Add a reply': 'Antworten',
            'Import Annotations': 'Importieren von Anmerkungen aus JSON-Datei',
            'Export Annotations': 'Anmerkung in JSON-Datei exportieren',
            'Export XFDF': 'Anmerkung in XFDF-Datei exportieren',
            'Import XFDF': 'Importieren von Anmerkungen aus der XFDF-Datei',
            Add: 'Hinzufügen',
            Clear: 'Löschen',
            Bold: 'Fett',
            Italic: 'Kursiv',
            Strikethroughs: 'Durchgestrichen',
            Underlines: 'Unterstreichen',
            Superscript: 'Exponent',
            Subscript: 'Subskript',
            'Align left': 'Links ausrichten',
            'Align right': 'Rechts ausrichten',
            Center: 'Mitte',
            Justify: 'Am Text ausrichten',
            'Font color': 'Schriftfarbe',
            'Text Align': 'Textausrichtung',
            'Text Properties': 'Schriftschnitt',
            SignatureFieldDialogHeaderText: 'Signatur hinzufügen',
            HandwrittenSignatureDialogHeaderText: 'Signatur hinzufügen',
            InitialFieldDialogHeaderText: 'Initial hinzufügen',
            HandwrittenInitialDialogHeaderText: 'Initial hinzufügen',
            'Draw Ink': 'Zeichnen',
            Create: 'Erstellen',
            'Font family': 'Schriftart',
            'Font size': 'Schriftgröße',
            'Free Text': 'Freitext',
            'Import Failed': 'Ungültiger JSON-Dateityp oder ungültiger Dateiname; Wählen Sie eine gültige JSON-Datei aus.',
            'File not found': 'Importierte JSON-Datei wird am gewünschten Speicherort nicht gefunden.',
            'Export Failed': 'Die Aktion "Anmerkungen exportieren" ist fehlgeschlagen. Bitte stellen Sie sicher, dass Anmerkungen ordnungsgemäß hinzugefügt wurden.',
            of: 'von',
            Dynamic: 'Dynamisch',
            'Standard Business': 'Standardgeschäft',
            'Sign Here': 'Hier unterschreiben',
            'Custom Stamp': 'Benutzerdefinierter Stempel',
            'Enter Signature as Name': 'Geben Sie Ihren Namen ein',
            'Draw-hand Signature': 'Unterschrift',
            'Type Signature': 'Art',
            'Upload Signature': 'Hochladen',
            'Browse Signature Image': 'Datei hochladen',
            'Save Signature': 'Signatur speichern',
            'Save Initial': 'Initial speichern',
            Textbox: 'Text',
            Password: 'Passwort',
            'Check Box': 'Kontrollkästchen',
            'Radio Button': 'Optionsfeld',
            Dropdown: 'Dropdown',
            'List Box': 'Listenfeld',
            Signature: 'Unterschrift',
            'Delete FormField': 'Formularfeld löschen',
            'Textbox Properties': 'Textbox-Eigenschaften',
            Name: 'Name',
            Tooltip: 'Quickinfo',
            Value: 'Wert',
            'Form Field Visibility': 'Sichtbarkeit von Formularfeldern',
            'Read Only': 'Schreibgeschützt',
            Required: 'Erforderlich',
            Checked: 'Geprüft',
            'Show Printing': 'Drucken anzeigen',
            Formatting: 'Format',
            Fill: 'Füllen',
            Border: 'Grenze',
            'Border Color': 'Rahmenfarbe',
            Thickness: 'Dicke',
            'Max Length': 'Max. Länge',
            'List Item': 'Artikelname',
            'Export Value': 'Artikelwert',
            'Dropdown Item List': 'Dropdownelementliste',
            'List Box Item List': 'Liste der Listenfeldelemente',
            General: 'Allgemein',
            Appearance: 'AUSSEHEN',
            Options: 'Optionen',
            'Delete Item': 'Löschen',
            Up: 'Hoch',
            Down: 'Runter',
            Multiline: 'Mehrzeilig',
            Revised: 'Überarbeitet',
            Reviewed: 'Geprüft',
            Received: 'Eingegangen',
            Confidential: 'Vertraulich',
            Approved: 'Gebilligt',
            'Not Approved': 'Nicht genehmigt',
            Witness: 'Zeuge',
            'Initial Here': 'Initial hier',
            Draft: 'Entwurf',
            Final: 'Final-Version',
            'For Release': 'Zur öffentlichen Veröffentlichung',
            'Not For Release': 'Nicht zur öffentlichen Veröffentlichung bestimmt',
            'For Comment': 'Kommentare',
            Void: 'Leere',
            'Preliminary Results': 'Vorläufige Ergebnisse',
            'Information Only': 'Nur Informationen',
            in: 'in',
            m: 'm',
            ft_in: 'ft_in',
            ft: 'Ft',
            p: 'p',
            cm: 'cm',
            mm: 'Mm',
            pt: 'Pt',
            cu: 'mit',
            sq: 'Sq',
            Initial: 'Initial'
          }
        }
      });
    }
    loadCldr();
  }
}
